<script setup lang="ts">

import Title from "../components/title.vue";
import Card1 from "/@/components/card-1.vue";
import {qq} from "/@/assets/qq.png"
import {ref} from "vue";
import mediafile from "/@/assets/mediafile.png"
import google_drive from "/@/assets/google_drive.png"
import github from "/@/assets/github-mark-white.svg"
const chinese=[
  { button: 'download', button_url: '/?tab=1', title: 'add_qun_download' },
  //{ button: 'download', button_url: 'https://ghfast.top/?q=https://github.com/pingfanH/clashmini-content/releases/download/1.1.0/CmReborn.APK', title: 'android', prop:{},icon:github },
  // { button: 'download', button_url: 'https://ghgo.xyz/?q=https://github.com/pingfanH/clashmini-content/releases/download/1.1.0/CM_Reborn.ipa', title: 'ios', prop:{},icon:github },

]
const normal = ref([
  { button: 'download', button_url: 'https://drive.google.com/file/d/1qMavZxSeovN7fDcPawvNoY1WCgHEpGdL/view?usp=sharing', title: 'android', prop:{},icon:google_drive },
  { button: 'download', button_url: 'https://www.mediafire.com/file/068thr6x23brxo6/CM_Reborn_1.2.0_sign.apk/file', title: 'android', prop:{},icon:mediafile },
  // { button: 'download', button_url: 'https://drive.google.com/file/d/1A4ZKhy3AP4-4dUDwjzPn1tOYFkXLi06w/view?usp=drive_link', title: 'ios', prop:{},icon:google_drive },
  // { button: 'download', button_url: 'https://www.mediafire.com/file/ajqjxizvcrwrk8q/CM_Reborn.ipa/file', title: 'ios', prop:{},icon:mediafile },
]);
// 根据 isChinese 函数决定将 chinese 数组插入在前面或后面
const combinedCards = ref(isChinese() ? [...chinese, ...normal.value] : [...normal.value, ...chinese]);
import {computedFontSize, paddingSize} from "/@/lib/font.ts";
import {isChinese} from "/@/lib/utils.ts";
</script>

<template>
  <Title :icon="false">{{$t('download')}}</Title>
  <div class="community-cards without-scrollbar">
    <Card1
        v-for="(card, index) in combinedCards"
        :key="index"
        :button="$t(card.button)"
        :button_url="card.button_url"
    >
      <div class="card-content" :style="{'fontSize':`${computedFontSize($t(card.title,card.prop),5,6)}dvh`}">
        <img v-if="card.icon" :src="card.icon"/>
        <div class="title">{{ $t(card.title,card.prop) }}</div>
      </div>
    </Card1>
  </div>

</template>

<style scoped lang="scss">
$color1: #ffffff;
.community-cards{
  display: flex;
  flex-direction: column;

  align-items: center;
  width: 100%;
  padding-top: 4vh;
  gap:2dvh;
  max-height: 70dvh;
  overflow-y: scroll;
  overflow-x: hidden;
}
.card-content{
  user-select: none;
  display: flex;
  flex-direction: row; // 让子元素垂直排列
  justify-content: center; // 让子元素上下居中
  align-items: center; // 让子元素左右占满
  width: 100%;
  height: 100%;
  img{
    width: 7dvh;
    padding-right: 1dvh;
  }
  .title{
    color: white;
    font-family: "wenfeng-mkzyt", sans-serif;
    //font-size: 5dvh;
  }
}

</style>
